import { render } from "./Form.vue?vue&type=template&id=5f5703e0&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=5f5703e0&lang=scss"
import "./Form.vue?vue&type=style&index=1&id=5f5703e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5703e0"]])

export default __exports__